import { UserProfileDto, UserRole, PaygapMetricItemDto } from "@green0meter/api-client";
import { useQuery } from "@tanstack/react-query";

import { DOMAIN_PAYGAP } from "../domain";

import { paygapApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_CURRENT_COMPANY_PAYGAP_METRICS = "GET_CURRENT_COMPANY_PAYGAP_METRICS";

const allowedRoles = [
  UserRole.Owner,
  UserRole.Manager,
  UserRole.Respondent,
  UserRole.Viewer,
  UserRole.Auditor,
];

export const getCurrentCompanyPaygapMetrics = async (): Promise<PaygapMetricItemDto[]> => {
  const response = await paygapApi.paygapControllerGetCurrentCompanyPaygapMetrics();

  return response.data;
};

export const useGetCurrentCompanyPaygapMetrics = (
  user: UserProfileDto | null,
): {
  paygapMetrics: PaygapMetricItemDto[] | undefined;
  getCurrentCompanyPaygapMetricsEnabled: boolean;
  getCurrentCompanyPaygapMetricsError: Error | null;
  refetchGetCurrentCompanyPaygapMetrics: () => void;
  isLoadingGetCurrentCompanyPaygapMetrics: boolean;
  isFetchingGetCurrentCompanyPaygapMetrics: boolean;
  isSuccessGetCurrentCompanyPaygapMetrics: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryResult = useQuery<PaygapMetricItemDto[], Error>({
    queryKey: [DOMAIN_PAYGAP, ACTION_GET_CURRENT_COMPANY_PAYGAP_METRICS],
    queryFn: () => getCurrentCompanyPaygapMetrics(),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    paygapMetrics: queryResult.data,
    getCurrentCompanyPaygapMetricsEnabled: enabled,
    getCurrentCompanyPaygapMetricsError: queryResult.error,
    refetchGetCurrentCompanyPaygapMetrics: queryResult.refetch,
    isLoadingGetCurrentCompanyPaygapMetrics: queryResult.isLoading,
    isFetchingGetCurrentCompanyPaygapMetrics: queryResult.isFetching,
    isSuccessGetCurrentCompanyPaygapMetrics: queryResult.isSuccess,
  };
};
